var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EChart',{staticClass:"m-0",attrs:{"options":_vm.chartOptions,"error":_vm.request.getError(),"loading":_vm.request.getLoading(),"type":"time","card":"","header":_vm.$t('numberOfOffersInTime'),"tooltip":_vm.$t('tooltip')}})
}
var staticRenderFns = []

export { render, staticRenderFns }